<template>
  <div class="settings">
    <h1>Settings</h1>
    <v-sheet class="pa-10">
      <v-switch
        hide-details
        color="info"
        inset
        label="Enable dark theme">
      </v-switch>
      <!-- <v-switch 
        v-model="$vuetify.theme.dark"
        hide-details
        color="info"
        inset
        label="Enable dark theme">
      </v-switch> -->
    </v-sheet>
  </div>
</template>

<script>
export default {

}
</script>